<div class="chat-timeline-wrapper">
  <!-- Timeline Area -->
  <div class="timeline-area" #timelineArea>
    @if (timelineItems.length === 0) {
      <div class="timeline-empty">
        {{ 'MAIN.CONTENT.TICKETS.CHAT_TIMELINE.EMPTY' | translate }}
      </div>
    }

    @if (timelineItems.length > 0) {
      <div class="timeline-content">
        @for (item of timelineItems; track item; let i = $index) {
          <!-- Date Divider -->
          @if (shouldShowDateDivider(item, i)) {
            <div class="date-divider">
              <span class="date-divider-text">{{ formatDateDivider(item.timestamp) }}</span>
            </div>
          }
          <!-- System Log -->
          @if (item.type === 'chat' && isSystemMessage(item)) {
            <div class="timeline-item log-item system-log">
              <div class="log-icon">
                <img src="assets/img/info.svg" alt="" onerror="this.style.display='none'">
              </div>
              <div class="log-content">
                <div class="log-title fs-14 font-weight-600">
                  {{ getSystemMessageText(item) }}
                </div>
                <div class="log-details fs-12 text-grey">
                  <span>{{ formatTime(item.timestamp) }}</span>
                </div>
              </div>
            </div>
          }
          <!-- Chat Message -->
          @if (item.type === 'chat' && !isSystemMessage(item)) {
            <div class="timeline-item chat-item"
              [ngClass]="{'own-message': isOwnMessage(item), 'other-message': !isOwnMessage(item)}">
              <div class="chat-bubble">
                @if (!isOwnMessage(item)) {
                  <div class="chat-sender fs-12 text-grey mb-1">
                    {{ item.data.senderName || getUsersName(item.data.userId) }}
                  </div>
                }
                <div class="chat-text" [innerHTML]="byPassHTML(item.data.text)"></div>
                <div class="chat-time fs-11 text-grey">
                  {{ formatTime(item.timestamp) }}
                </div>
              </div>
            </div>
          }
          <!-- Session Log -->
          @if (item.type === 'session') {
            <div class="timeline-item log-item session-log" (click)="onSessionClick(item.data)">
              <div class="log-icon">
                <img src="assets/img/vsight-logo.svg" alt="" onerror="this.style.display='none'">
              </div>
              <div class="log-content">
                <div class="log-title fs-14 font-weight-600">
                  {{ 'MAIN.CONTENT.TICKETS.CHAT_TIMELINE.SESSION_ATTACHED' | translate }}
                </div>
                <div class="log-details fs-12 text-grey">
                  @if (item.data.start_time && item.data.end_time) {
                    <span>
                      {{ getDuration(item.data.start_time, item.data.end_time) }} min
                    </span>
                  }
                  <span class="mx-1">•</span>
                  <span>{{ formatTime(item.timestamp) }}</span>
                </div>
              </div>
            </div>
          }
          <!-- File Log -->
          @if (item.type === 'file') {
            <div class="timeline-item log-item file-log" (click)="onFileClick(item.data)">
              <div class="log-icon">
                @if (isImageFile(item.data)) {
                  <img [src]="item.data.url" alt="" class="file-thumbnail">
                }
                @if (!isImageFile(item.data)) {
                  <img src="assets/img/file-icon.svg" alt="" onerror="this.style.display='none'">
                }
              </div>
              <div class="log-content">
                <div class="log-title fs-14 font-weight-600 text-truncate">
                  {{ item.data.name }}
                </div>
                <div class="log-details fs-12 text-grey">
                  @if (item.data.uploader_name || item.data.uploader_id) {
                    <span>
                      {{ item.data.uploader_name || getUsersName(item.data.uploader_id) }}
                    </span>
                  }
                  <span [class.mx-1]="item.data.uploader_name || item.data.uploader_id">
                    {{ 'MAIN.CONTENT.TICKETS.CHAT_TIMELINE.UPLOADED_BY' | translate }}
                  </span>
                  <span class="mx-1">•</span>
                  <span>{{ formatTime(item.timestamp) }}</span>
                </div>
              </div>
            </div>
          }
        }
      </div>
    }
  </div>

  <!-- Chat Input Area -->
  <div class="chat-input-container">
    <div class="chat-input-wrapper">
      <div class="d-flex align-items-center">
        <div class="quill-wrapper flex-grow-1">
          <quill-editor
            class="d-block"
            (onContentChanged)="getContent($event)"
            (onEditorCreated)="onEditorCreated($event)"
            [(ngModel)]="commentText"
            [placeholder]="'MAIN.CONTENT.TICKETS.CHAT_TIMELINE.PLACEHOLDER' | translate"
            [modules]="modules"
            [style]="{'min-height': '50px', 'max-height': '120px'}">
          </quill-editor>
        </div>
        <div class="chat-actions d-flex align-items-center ms-2">
          <input type="file" class="d-none" accept="*" onclick="this.value = null"
            (change)="chooseButtonUpload($event)" #fileInput multiple>
          <img src="assets/img/attach-icon-blue.svg" alt="" class="attach-btn cursor-pointer me-2"
            (click)="fileInput.click()" title="{{ 'MAIN.CONTENT.TICKETS.CHAT_TIMELINE.ATTACH_FILE' | translate }}">
          <button class="v-btn btn btn-primary vsight-button send-btn"
            (click)="sendComment()"
            [disabled]="isCommentSending || !hasContent">
            {{ 'MAIN.CONTENT.TICKETS.CHAT_TIMELINE.SEND' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
